import { useAuthMember, useNetwork } from '@tribeplatform/react-sdk/hooks';
import { useI18n } from '../../i18n';
export const useCommandBarNavigation = () => {
    var _a;
    const intl = useI18n();
    const { isGuest, data: member, isLoading } = useAuthMember();
    const { data: network } = useNetwork();
    if (isGuest)
        return {
            isLoading: false,
            actions: [
                {
                    name: 'Log in',
                    url: `/auth/login`,
                    category: 'General',
                    hotkey: 'option+l,alt+l',
                },
            ],
        };
    const { privateMessagingEnabled } = ((_a = network === null || network === void 0 ? void 0 : network.settings) === null || _a === void 0 ? void 0 : _a.privateMessaging) || {};
    const categoryTexts = {
        navigation: intl.$t({
            id: 'Generics.Navigation',
            defaultMessage: 'Navigation',
        }),
        general: intl.$t({
            id: 'CommandBar.Navigation.General',
            defaultMessage: 'General',
        }),
    };
    return {
        isLoading,
        actions: [
            {
                name: intl.$t({
                    id: 'CommandBar.Navigation.GoToHome',
                    defaultMessage: 'Go to home',
                }),
                url: `/`,
                category: categoryTexts.navigation,
            },
            {
                name: intl.$t({
                    id: 'CommandBar.Navigation.GoToMyNotifications',
                    defaultMessage: 'Go to my notifications',
                }),
                url: `/notifications`,
                category: categoryTexts.navigation,
            },
            privateMessagingEnabled && {
                name: intl.$t({
                    id: 'CommandBar.Navigation.GoToMyMessages',
                    defaultMessage: 'Go to my messages',
                }),
                url: `/messaging`,
                category: categoryTexts.navigation,
            },
            {
                name: intl.$t({
                    id: 'CommandBar.Navigation.GoToMyProfile',
                    defaultMessage: 'Go to my profile',
                }),
                url: `/member/${member === null || member === void 0 ? void 0 : member.id}`,
                category: categoryTexts.navigation,
            },
            {
                name: intl.$t({
                    id: 'CommandBar.Navigation.GoToMyAccountSettings',
                    defaultMessage: 'Go to my account settings',
                }),
                url: `/settings/account`,
                category: categoryTexts.navigation,
            },
            {
                name: intl.$t({
                    id: 'CommandBar.Navigation.GoToMyNotificationSettings',
                    defaultMessage: 'Go to my notification settings',
                }),
                url: `/settings/notifications`,
                category: categoryTexts.navigation,
            },
            {
                name: intl.$t({
                    id: 'Generics.SignOut',
                    defaultMessage: 'Sign out',
                }),
                url: `/auth/logout`,
                category: categoryTexts.general,
                hotkey: 'option+shift+q,alt+shift+q',
            },
        ],
    };
};
//# sourceMappingURL=useCommandBarNavigation.js.map